var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.496 12.501v7.498H5.501v-7.498h2.995zm6.76-1.5h-3.5a.75.75 0 00-.75.75v3.502c0 .414.334.75.75.75h3.5a.75.75 0 00.75-.75v-3.502a.75.75 0 00-.75-.75zm-.75 1.5v2.002h-2.002v-2.002h2.002zm-8.34-7.499H1.502v1.165c0 1.18.878 2.157 2.017 2.311l.156.016.16.005a2.332 2.332 0 002.327-2.173l.006-.16V5.003l-.002-.001zm6.165 0H7.667v1.165c0 1.18.878 2.157 2.017 2.311l.156.016.16.005a2.332 2.332 0 002.327-2.173l.006-.16V5.003l-.002-.001zm6.167 0h-4.665l.001 1.165c0 1.18.878 2.157 2.016 2.311l.157.016.16.005a2.333 2.333 0 002.327-2.173l.005-.16V5.002zM7.062 1.5H4.327L2.471 3.502h3.977L7.062 1.5zm4.308 0H8.632l-.616 2.002h3.97L11.37 1.5zm4.304 0h-2.733l.615 2.002h3.976L15.674 1.5zM.204 3.742L3.45.24a.75.75 0 01.446-.233L4.001 0h12c.173 0 .341.06.475.169l.075.07 3.273 3.53.03.038c.102.136.148.29.148.44L20 6.167c0 .994-.378 1.9-1 2.58V19.25a.75.75 0 01-.648.743L18.25 20l-8.253-.001v-8.248a.75.75 0 00-.75-.75H4.751a.75.75 0 00-.75.75v8.248L1.753 20a.75.75 0 01-.744-.648l-.006-.102-.002-10.502a3.818 3.818 0 01-.995-2.384l-.005-.197V4.29a.728.728 0 01.096-.408l.05-.076.055-.065.001.001z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplace);
export default __webpack_public_path__ + "static/media/marketplace.db159b798a7bfe53f3e908f5b31a55c3.svg";
export { ForwardRef as ReactComponent };